import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import { getFloorButtonLabel } from '@/utils/floor-guide';
import styles from './styles.module.scss';
import clsx from 'clsx';

type Props = BaseButtonProps & {
    isSelected?: boolean;
    variant?: 'default' | 'horizontal';
};
export const FloorButton = ({ children, isSelected, variant = 'default', className, ...props }: Props) => {
    const displayLabel = typeof children === 'string' ? getFloorButtonLabel(children) : children;
    return (
        <BaseButton
            {...props}
            className={clsx(
                styles['floor-button'],
                variant === 'horizontal' && styles['floor-button--horizontal'],
                isSelected && styles['floor-button--selected'],
                className
            )}
        >
            <span className={clsx(styles['floor-button__number'], 'number')}>{displayLabel}</span>
        </BaseButton>
    );
};
